<div class="full-height" fxLayout="row">
  <app-planning-item-form
    *ngIf="canModifyPlanningItem(); else planningItemDetails"
    fxFlex="100"
    [planningItem]="planningItem"
    [machine]="machine"
    (savePlanningItem)="save($event)"
    (deletePlanningItem)="delete()"
    (closePlanningItem)="close()"
    (planningItemChange)="onPlanningItemChange($event)"
    (selectPlanningOrder)="onPlanningOrderSelected($event)"
  ></app-planning-item-form>
  <ng-template #planningItemDetails>
    <app-planning-item-details
      fxLayout="column"
      fxFlex="100"
      [planningItem]="planningItem"
      [machine]="machine"
      (deletePlanningItem)="delete()"
      (closePlanningItem)="close()"
      (selectPlanningOrder)="onPlanningOrderSelected($event)"
    ></app-planning-item-details>
  </ng-template>
</div>
